import { PluginKey } from '@atlaskit/editor-prosemirror/state';

export const codeBidiWarningPluginKey = new PluginKey('codeBidiWarningPlugin');
